import { HtmlWidgetSchema, isHtmlWidgetKey, type HtmlWidget } from '@inference.engine/widgets/web';

interface StoredVersion {
  messageId: string;
  widget: { key?: unknown; data?: unknown; artifactId?: unknown; agentName?: unknown };
}

export interface InlineWidget {
  key: string;
  agentName: string;
  artifactId?: string;
  widget: HtmlWidget;
}

/**
 * The inline widgets a reply shows, one per widget: a later version replaces an earlier one in
 * place, so a fix the agent makes after the first render does not add a second frame.
 */
export function inlineWidgetsOf(
  histories: Record<string, { versions: StoredVersion[] }>,
  messageId: string,
): InlineWidget[] {
  const latest = new Map<string, InlineWidget>();
  for (const [historyAgentId, history] of Object.entries(histories)) {
    for (const { messageId: versionMessageId, widget } of history.versions) {
      if (versionMessageId !== messageId) continue;
      if (typeof widget.key !== 'string' || !isHtmlWidgetKey(widget.key)) continue;
      const parsed = HtmlWidgetSchema.safeParse(widget.data);
      if (!parsed.success || parsed.data.placement !== 'inline') continue;
      latest.set(widget.key, {
        key: widget.key,
        agentName: typeof widget.agentName === 'string' ? widget.agentName : historyAgentId,
        artifactId: typeof widget.artifactId === 'string' ? widget.artifactId : undefined,
        widget: parsed.data,
      });
    }
  }
  return [...latest.values()];
}
